import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AiSearchIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "AiSearch",
    children: [/*#__PURE__*/_jsx("path", {
      d: "m29.38 27.763-6.836-6.835a11.42 11.42 0 0 0 2.592-7.067q.014-.105.01-.211c-.027-.614-.54-1.18-1.152-1.18h-.02c-.576.013-1.047.524-1.115 1.092q-.007.075-.007.151c-.006 5.036-4.105 9.132-9.143 9.132-5.042 0-9.143-4.102-9.143-9.143 0-4.787 3.736-8.794 8.507-9.121a1.144 1.144 0 0 0 1.062-1.218A1.15 1.15 0 0 0 12.916 2.3C6.952 2.71 2.28 7.718 2.28 13.702c0 6.301 5.127 11.429 11.429 11.429 2.737 0 5.253-.969 7.223-2.583l6.831 6.831a1.14 1.14 0 0 0 1.616 0 1.14 1.14 0 0 0 0-1.616"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.429 8c0 .51.417.929.928.929A5.576 5.576 0 0 1 17.93 14.5c0 .51.417.929.928.929.51 0 .929-.418.929-.929a5.576 5.576 0 0 1 5.571-5.571c.51 0 .929-.418.929-.929a.93.93 0 0 0-.929-.929A5.576 5.576 0 0 1 19.786 1.5a.93.93 0 0 0-.929-.929.93.93 0 0 0-.928.929 5.576 5.576 0 0 1-5.572 5.571.93.93 0 0 0-.928.929"
    })]
  }));
};
AiSearchIcon.displayName = 'AiSearchIcon';